import { CreateNextStepLink, DefaultOauthLink, ForgotPasswordLink, LoginLink } from "../constants/general";
import { DomUtils } from "../utils/domUtils";
import { ExternalProviders } from "../components/externalProviders";
import { LocationUtils } from "../utils/locationUtils";
import { ValidatedInput } from "../components/validatedInput";
import { BaseController } from "./base";

export const SignUpConstants = {
	loginLink: "loginLink",
	signUpForm: "signUpForm",
	firstName: "firstName",
	lastName: "lastName",
	emailAddress: "emailAddress",
	mobilePhone: "mobilePhone",
	signUpWithLabel: "signUpWithLabel",
	externalProvidersContainer: "externalProvidersContainer",
	signUpButton: "signUpButton",
	returnUrlHidden: "returnUrl",
	signInHidden: "signIn",
	isExternalRegistrationHidden: "isExternalRegistration"
};

export class SignUpController extends BaseController {
	constructor() {
		super();

		this._message = null;
		this._signIn = null;
		this._loginLink = null;
		this._forgotPasswordLink = null;
		this._returnUrl = null;
		this._firstName = null;
		this._lastName = null;
		this._emailAddress = null;
		this._mobilePhone = null;
		this._isExternalRegistration = null;
		this._externalProviders = null;
	}

	Init() {
		this._GetContextData();

		this._ShowMessage(this._message);

		this._SetupForm();
		this._SetupExternalProviders(this._externalProviders, this._isExternalRegistration);

		this._SetupPhoneMask(SignUpConstants.mobilePhone, this._domainPhoneMask);
		this._SetInitialFocus();

		this._BindEvents();
	}

	_GetContextData() {
		this._message = LocationUtils.GetQueryParam("errMessage") || window.message;

		this._signIn = LocationUtils.GetQueryParam("signin");

		if (!!this._signIn) {
			this._loginLink = `${LoginLink}${this._signIn}`;
		}
		else {
			this._loginLink = DefaultOauthLink;
		}

		if (!!window.viewModel) {
			this._forgotPasswordLink = `${ForgotPasswordLink}${this._signIn}`;

			this._returnUrl = window.viewModel.ReturnUrl;

			this._firstName = window.viewModel.FirstName;
			this._lastName = window.viewModel.LastName;
			this._emailAddress = window.viewModel.EmailAddress;
			this._mobilePhone = window.viewModel.MobilePhone;

			this._isExternalRegistration = window.viewModel.IsExternalRegistration;
			this._externalProviders = window.externalProviders;
		}
	}

	_SetupForm() {
		const loginLinkElement = DomUtils.GetElement(SignUpConstants.loginLink);
		loginLinkElement.href = this._loginLink;

		const firstNameElement = DomUtils.GetElement(SignUpConstants.firstName);
		firstNameElement.value = this._firstName;
		ValidatedInput.Init(firstNameElement);

		const lastNameElement = DomUtils.GetElement(SignUpConstants.lastName);
		lastNameElement.value = this._lastName;
		ValidatedInput.Init(lastNameElement);

		const emailAddressElement = DomUtils.GetElement(SignUpConstants.emailAddress);
		emailAddressElement.value = this._emailAddress;
		ValidatedInput.Init(emailAddressElement);

		const mobilePhoneElement = DomUtils.GetElement(SignUpConstants.mobilePhone);
		mobilePhoneElement.value = this._mobilePhone;

		const returnUrlElement = DomUtils.GetElement(SignUpConstants.returnUrlHidden);
		returnUrlElement.value = this._returnUrl;

		const signInElement = DomUtils.GetElement(SignUpConstants.signInHidden);
		signInElement.value = this._signIn;

		const isExternalRegistrationElement = DomUtils.GetElement(SignUpConstants.isExternalRegistrationHidden);
		isExternalRegistrationElement.value = this._isExternalRegistration;

		const signUpFormElement = DomUtils.GetElement(SignUpConstants.signUpForm);
		signUpFormElement.action = CreateNextStepLink + this._signIn;
	}

	_SetupExternalProviders(providers, isExternalRegistration) {
		const hasProviders = isExternalRegistration === false && providers && providers.length > 0;

		const signUpWithLabelElement = DomUtils.GetElement(SignUpConstants.signUpWithLabel);
		signUpWithLabelElement.style.display = hasProviders ? "block" : "none";

		const externalProvidersContainerElement = DomUtils.GetElement(SignUpConstants.externalProvidersContainer);
		externalProvidersContainerElement.style.display = hasProviders ? "block" : "none";

		if (hasProviders === true) {
			ExternalProviders.Init(externalProvidersContainerElement, providers, (providerType) =>
				this._OnExternalProviderClicked(providerType)
			);
		}
	}

	_SetInitialFocus() {
		if (!this._firstName) {
			this._FocusElement(SignUpConstants.firstName);
		}
		else if (!this._lastName) {
			this._FocusElement(SignUpConstants.lastName);
		}
		else if (!this._emailAddress) {
			this._FocusElement(SignUpConstants.emailAddress);
		}
		else if (!this._mobilePhone) {
			this._FocusElement(SignUpConstants.mobilePhone);
		}
	}

	_BindEvents() {
		this._BindSignUpButton();
	}

	_BindSignUpButton() {
		const signUpButtonElement = DomUtils.GetElement(SignUpConstants.signUpButton);
		signUpButtonElement.addEventListener("click", this._OnSignUp.bind(this));
	}

	_OnSignUp() {
		if (this._Validate()) {
			this._SubmitForm();
		}
	}

	_OnExternalProviderClicked(providerType) {
		const provider = this._externalProviders?.find((p) => p.Type === providerType);
		if (provider != null) {
			window.location.href = provider.Href;
		}
	}

	/* istanbul ignore next */
	_SubmitForm() {
		super._SubmitForm(SignUpConstants.signUpForm);
	}

	_Validate() {
		let result = true;

		if (this._ValidateElement(SignUpConstants.firstName) != null) {
			this._FocusElement(SignUpConstants.firstName);
			result = false;
		}

		if (this._ValidateElement(SignUpConstants.lastName) != null) {
			this._FocusElement(SignUpConstants.lastName);
			result = false;
		}

		if (this._ValidateElement(SignUpConstants.emailAddress) != null) {
			this._FocusElement(SignUpConstants.emailAddress);
			result = false;
		}

		return result;
	}
}
